import { ref } from 'vue';
import type { SelectOption } from '../types';

export function useTabs<T>(
    tabs: SelectOption<T>[],
    defaultTab?: T
) {
    const selectedTab = ref<T>(defaultTab || tabs[0].value);

    const setTab = (value: T) => {
        selectedTab.value = value;
    }

    return [
        selectedTab,
        tabs,
        setTab,
    ] as const;
}
